import { render, staticRenderFns } from "./PackageComponent.vue?vue&type=template&id=de896596&"
import script from "./PackageComponent.vue?vue&type=script&lang=js&"
export * from "./PackageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports